/*
  BDEK quick add (snippets/bdek-product-card.liquid).
  - "Quick add" toggles the size list (aria-expanded).
  - In-stock sizes: one tap adds to cart.
  - Pre-order sizes: the first tap shows "[size] is on pre-order and ships by [date]."
    with an "Add pre-order" button; only that button adds it.
  - Adds post to /cart/add.js, then fire Impulse's "ajaxProduct:added" event from
    the form so the cart drawer rebuilds and opens.
  - Without JavaScript the forms still work as normal add-to-cart posts
    (pre-order sizes still carry their "Ships by" line item property).
*/
(function () {
  if (window.bdekQuickAddReady) return;
  window.bdekQuickAddReady = true;

  var pendingForm = null;

  function hideConfirm(wrap) {
    var confirm = wrap && wrap.querySelector('[data-bdek-confirm]');
    if (confirm) confirm.hidden = true;
    if (wrap) {
      wrap.querySelectorAll('.bdek-card__size[aria-pressed="true"]').forEach(function (b) {
        b.removeAttribute('aria-pressed');
      });
    }
    pendingForm = null;
  }

  function closeAll(except) {
    document.querySelectorAll('[data-bdek-quick-toggle][aria-expanded="true"]').forEach(function (btn) {
      if (btn === except) return;
      btn.setAttribute('aria-expanded', 'false');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = true;
      hideConfirm(btn.closest('[data-bdek-quick-add]'));
    });
  }

  function addToCart(form) {
    var wrap = form.closest('[data-bdek-quick-add]');
    var status = wrap && wrap.querySelector('[data-bdek-status]');
    var button = form.querySelector('[type="submit"]');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Could not add to cart');
          return data;
        });
      })
      .then(function (product) {
        if (status) status.textContent = status.dataset.added || 'Added to cart';
        hideConfirm(wrap);
        closeAll();
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: product } }));
      })
      .catch(function (error) {
        if (status) status.textContent = error.message;
      })
      .finally(function () {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-bdek-quick-toggle]');
    if (toggle) {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      closeAll(toggle);
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (panel) {
        panel.hidden = open;
        if (open) {
          hideConfirm(toggle.closest('[data-bdek-quick-add]'));
        } else {
          var first = panel.querySelector('button');
          if (first) first.focus();
        }
      }
      return;
    }

    var confirmAdd = event.target.closest('[data-bdek-confirm-add]');
    if (confirmAdd) {
      if (pendingForm && window.fetch) addToCart(pendingForm);
      return;
    }

    if (!event.target.closest('[data-bdek-quick-add]')) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var wrap = event.target.closest && event.target.closest('[data-bdek-quick-add]');
    if (!wrap) return;
    var toggle = wrap.querySelector('[data-bdek-quick-toggle]');
    closeAll();
    hideConfirm(wrap);
    if (toggle) toggle.focus();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-bdek-add-form]');
    if (!form || !window.fetch) return;
    event.preventDefault();

    var submitter = event.submitter || form.querySelector('[type="submit"]');
    var message = submitter && submitter.getAttribute('data-bdek-preorder');
    var wrap = form.closest('[data-bdek-quick-add]');

    if (message && wrap) {
      // Pre-order: show the message and wait for "Add pre-order"
      var confirm = wrap.querySelector('[data-bdek-confirm]');
      var text = wrap.querySelector('[data-bdek-confirm-text]');
      if (confirm && text) {
        wrap.querySelectorAll('.bdek-card__size[aria-pressed="true"]').forEach(function (b) {
          b.removeAttribute('aria-pressed');
        });
        if (submitter.classList.contains('bdek-card__size')) submitter.setAttribute('aria-pressed', 'true');
        text.textContent = message;
        confirm.hidden = false;
        pendingForm = form;
        var addButton = confirm.querySelector('[data-bdek-confirm-add]');
        if (addButton) addButton.focus();
        return;
      }
    }

    addToCart(form);
  });
})();
